var map = {
	"./amos.jpg": 50321,
	"./david-seisun.jpg": 77355,
	"./jeremy-mifsud.jpg": 72650,
	"./jonathan-mifsud.jpg": 57001,
	"./rose-bonnici.jpg": 20053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59470;